import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PersonalParams, PersonalParamsParams } from 'src/app/shared/models/iCourrier/me/personal-params';
import * as async from 'async';
import { ParamsService } from 'src/app/shared/services/params.service';
import { SystemParams } from 'src/app/shared/models/iCourrier/params-admin/system-params';
import { MeService } from 'src/app/shared/services/me.service';

@Component({
  selector: 'app-personal-params',
  templateUrl: './personal-params.component.html',
  styleUrls: ['./personal-params.component.scss'],
})
export class PersonalParamsComponent implements OnInit {
  public buttons = [
    {
      text: 'Enregistrer',
      styleClass: 'green',
      disabled: false,
      tooltip: 'Enregistrer',
      id: 'savePersonalParamsId',
      click: () => {
        this.saveParams();
      },
    },
  ];

  public form: UntypedFormGroup = new UntypedFormGroup({
    ICourrierDisplayClassementId: new UntypedFormControl(0),
  });
  public myPersonalParams: Array<PersonalParams> = [];

  public hideClassementParams = false; //* Displays the params ICourrierDisplayClassementId

  constructor(
    public toastr: ToastrService,
    private params: ParamsService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.params.getParamsSystem().subscribe({
      next: (res: SystemParams[]) => {
        const hideClassementParams = res.filter((x) => x.paramName === 'IAppsICourrierHideClassementDossier');
        if (hideClassementParams.length > 0) {
          this.hideClassementParams = this.setDataToBoolean(hideClassementParams[0].paramValue);
        }
        this.meService.getMyPersonalParams('CourrierCustomViews').subscribe({
          next: (res) => {
            //* Pour chaque variable on va voir si elle existe dans les paramètres enregistrés. Si oui, on set sa valeur
            if (!this.hideClassementParams) {
              //* Si on ne cache pas la valeur => on va la récupérer si non cela ne sert a rien de faire du code pour rien
              const index = res.map((x) => x.name).indexOf('ICourrierDisplayClassementId');
              if (index > -1) {
                this.form.patchValue({
                  ICourrierDisplayClassementId: res[index].value === '1' ? true : false,
                });
              }
            }
            this.myPersonalParams = res;
          },
        });
      },
    });
  }

  saveParams(): void {
    async.eachSeries(
      Object.keys(this.form.value),
      (x, nextItem) => {
        //* 1st let's check if the form value should be sent by checking if it's shown or not
        //! Do not forget to check your var if it's linked to a display right!
        if (x === 'ICourrierDisplayClassementId' && !this.hideClassementParams) {
          //* let's check if the value exists. If it does => PUT, if not => POST
          const index = this.myPersonalParams.map((x) => x.name).indexOf(x);
          if (index > -1) {
            this.myPersonalParams[index].value = this.form.value[x] === true ? '1' : '0';
            this.meService.putMyPersonalParams(this.myPersonalParams[index].id, 'CourrierCustomViews', this.myPersonalParams[index]).subscribe({
              next: () => {
                nextItem();
              },
            });
          } else {
            const data: PersonalParamsParams = {
              name: x,
              description: x,
              value: this.form.value[x] === true ? '1' : '0',
            };
            this.meService.postMyPersonalParams('CourrierCustomViews', data).subscribe({
              next: () => {
                nextItem();
              },
            });
          }
        } else {
          //* Si on arrive ici c'est que la valeur n'est pas affichée => ne doit PAS etre envoyée en DB
          nextItem();
        }
      },
      () => {
        this.toastr.success('Les paramètres personnels ont bien été sauvegardés');
      }
    );
  }

  setDataToBoolean(data): boolean {
    if (data === true || data === '1') {
      return true;
    }
    if (data === false || data === '0') {
      return false;
    }
  }
}
